module.exports = __webpack_public_path__ + "img/right.ec2e9f9d.svg";